import AppHeader from '../../layout/AppHeader';
import PdvMain from '../../xpost/pdv/PdvMain.vue';
import PdvCall from '../../xpost/pdv/PdvCall.vue';
import PdvReport from '../../xpost/pdv/PdvReport.vue';
import PdvReverseAuthorizationList from '../../xpost/pdv/PdvReverseAuthorizationList.vue';
import PdvReverseAuthorization from '../../xpost/pdv/PdvReverseAuthorization.vue';
import PdvTimeline from '../../xpost/pdv/PdvTimeline.vue';
import PdvListAuthorization from '../../xpost/pdv/PdvListAuthorization.vue';
import PdvCallCloseCashier from '../../xpost/pdv/call/PdvCallCloseCashier.vue'

const PdvRoutes = [
  {
    path: "/servicos/pdv",
    name: "pdv",
    components: {
      header: AppHeader,
      default: PdvMain,
    }
  },
  {
    path: "/servicos/pdv/atendimento",
    name: "pdv.call",
    components: {
      header: AppHeader,
      default: PdvCall,
    }
  },
  {
    path: "/servicos/pdv/caixa",
    name: "pdv.cashier.close",
    components: {
      header: AppHeader,
      default: PdvCallCloseCashier,
    }
  },
  {
    path: "/servicos/pdv/configuracao",
    name: "pdv.config",
    redirect: { name: "pdv" },
  },
  {
    path: "/servicos/pdv/autorizacao",
    name: "pdv.authorization",
    components: {
      header: AppHeader,
      default: PdvListAuthorization,
    }
  },
  {
    path: "/servicos/pdv/relatorio",
    name: "pdv.report",
    components: {
      header: AppHeader,
      default: PdvReport,
    }
  },
  {
    path: "/servicos/pdv/timeline",
    name: "pdv.timeline",
    components: {
      header: AppHeader,
      default: PdvTimeline,
    }
  },
  {
    path: "/servicos/pdv/reversa",
    name: "pdv.authorization.reverse",
    components: {
      header: AppHeader,
      default: PdvReverseAuthorizationList,
    }
  },
  {
    path: "/servicos/pdv/reversa/pendencia",
    name: "pdv.authorization.reverse.pendencies",
    components: {
      header: AppHeader,
      default: PdvReverseAuthorization,
    }
  },
]

export default PdvRoutes;
